import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { NO_ACCESS_URL } from '../../access-control';

const RedirectToNoAccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(NO_ACCESS_URL, { replace: true });
  }, []);

  return null;
};

export default RedirectToNoAccess;
